import { render, staticRenderFns } from "./RingbaPhoneNumber.vue?vue&type=template&id=610f8b0a&scoped=true&"
import script from "./RingbaPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./RingbaPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./RingbaPhoneNumber.vue?vue&type=style&index=0&id=610f8b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f8b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
